var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerfVjyjdhq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "59px",
    viewBox: "0 0 39 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Get-QR-Code",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "049.-Locate-on-Map---Blank",
    transform: "translate(-161.000000, -331.000000)",
    fill: "#00AFCB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.5,331 C191.269553,331 200,339.730447 200,350.5 C200,357.679702 193.5,370.846368 180.5,390 C167.5,370.846368 161,357.679702 161,350.5 C161,339.730447 169.730447,331 180.5,331 Z M180.5,342 C176.357864,342 173,345.357864 173,349.5 C173,353.642136 176.357864,357 180.5,357 C184.642136,357 188,353.642136 188,349.5 C188,345.357864 184.642136,342 180.5,342 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerfVjyjdhq);
export default __webpack_public_path__ + "static/media/marker~fVJYJDHQ.9db1dbca61295992cfa0888b95c5d5a6.svg";
export { ForwardRef as ReactComponent };